export const menu = () => ({});

export default menu;
